import React from 'react'
import { Card, CardContent } from '@mui/material'
import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'
import Footer from 'examples/Footer'
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout'
import DashboardNavbar from 'examples/Navbars/DashboardNavbar'
import AddItemsWizard from './AddItemsWizard'

function AddItems() {
    return (
        <DashboardLayout>
            <DashboardNavbar />

            <MDBox
                pt={4}
                pb={6}
                px={{ xs: 2, sm: 3, md: 4 }}
                maxWidth="1200px"
                mx="auto"
            >
                <Card
                    sx={{
                        borderRadius: 3,
                        overflow: "hidden",
                        boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
                    }}
                >
                    {/* Header Section */}
                    <MDBox
                        px={4}
                        py={3}
                        sx={{
                            background: "rgb(38, 40, 51)",
                            borderBottom: "1px solid rgba(255,255,255,0.06)",
                        }}
                    >
                        <MDTypography
                            variant="h4"
                            fontWeight="bold"
                            color="white"
                            gutterBottom
                        >
                            Add Items / Assets
                        </MDTypography>

                        <MDTypography
                            variant="body2"
                            color="white"
                            sx={{ opacity: 0.75, maxWidth: "600px" }}
                        >
                            Add new tanks or assets to an existing address.
                        </MDTypography>
                    </MDBox>

                    {/* Content Section */}
                    <CardContent sx={{ px: { xs: 2, md: 4 }, py: 4 }}>
                        <AddItemsWizard />
                    </CardContent>
                </Card>
            </MDBox>

            <Footer />
        </DashboardLayout>
    )
}

export default AddItems